<div class="cards">
    @for (card of cards; track card.key) {
        <div class="card" [tooltip]="[card.tooltip]">
            <span class="card-icon">
                @if (card.icon) {
                    <span class="material-symbols-outlined">{{card.icon}}</span>
                }@else if (card.image) {
                    <img [src]="card.image" alt=""/>
                }@else if (card.type) {
                    <app-node-svg [type]="card.type" [noText]="true" [height]="28" [caller]="'Insights card: ' + card.title"></app-node-svg>
                }
            </span>
            <div class="card-body">
                <div class="card-title">{{card.title}}</div>
                <div class="value-row">
                    <span class="card-value" [style]="card.getFontColour()">{{card.getValueToDisplay(locale, currency)}}</span>
                    @if (card.units) {
                        <span class="units-value">{{card.units}}</span>
                    }
                </div>
                @if (card.hasComparison) {
                    <div class="compare">
                        <span class="change" [class.up]="card.change > 0" [class.down]="card.change < 0">
                            {{card.change > 0 ? '▲' : card.change < 0 ? '▼' : ''}} {{card.changePercentage}}
                        </span>
                        <span class="compare-value">from {{card.getChangeValueToDisplay(locale, currency)}}</span>
                    </div>
                }
                @if (card.total || card.valueType == INSIGHT_VALUE_TYPE.PERCENTAGE) {
                    <div class="meter" role="meter" [attr.aria-valuenow]="card.percentage" aria-valuemin="0" aria-valuemax="100">
                        <span [style.width.%]="card.percentage > 100 ? 100 : card.percentage < 0 ? 0 : card.percentage"></span>
                    </div>
                }
            </div>
        </div>
    }
</div>
